import { getGenericChannelId } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
// @ts-expect-error module not typed
import { isCommonMessageFormat } from 'conversations-message-history/common-message-format/operators/cmfComparators';
export const getDidChannelSwitch = (currentCommonMessage, lastCommonMessageGenericChannelId) => {
  if (!isCommonMessageFormat(currentCommonMessage)) return false;
  const currentGenericChannelId = getGenericChannelId(currentCommonMessage);
  return currentGenericChannelId !== lastCommonMessageGenericChannelId;
};